import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterExperiments } from '../../Components/Public/Filters/FilterExperiments.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BreadTags } from '../../Components/Public/Document/BreadTags.js';
import { BlockLogoExperiments } from '../../Components/Public/Logos/BlockLogoExperiments.js';
import { BlockTitleExperiments } from '../../Components/Public/Blocks/BlockTitleExperiments.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BlockExperiments } from '../../Components/Public/Blocks/BlockExperiments.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Experiments = (props) => {
    const { navParks } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [experiments, setExperiments] = useState([]);
    const [series, setSeries] = useState([]);
    const [authors, setAuthors] = useState([]);
    const [body, setBody] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasSeries = await fetch(`${backend}/series`, GetHeaders(guest));
            const series = await datasSeries.json();
            setSeries(series);
            const datasAuthors = await fetch(`${backend}/authors`, GetHeaders(guest));
            const authors = await datasAuthors.json();
            setAuthors(authors);
            const datasExperiments = await fetch(`${backend}/experiments`, GetHeaders(guest));
            const experiments = await datasExperiments.json();
            setExperiments(experiments);
            const datasBody = await fetch(`${backend}/experiments/body`, GetHeaders(guest));
            const body = await datasBody.json();
            setBody(body);
        };
        fetchData();
        ScrollTop();
    }, [backend, guest]);
    const items = GetDescription('experiments', { body: body, authors: authors });
    return (
        <div className="experiments">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="experiments" />
            <section className="infos">
                <div>
                    <BreadTags label="experiments" datas={series} />
                    {series.map((serie, i) => {
                        let label = `${serie.id - 1}00`;
                        let title = `Série ${label} - ${serie.name} (${series.length})`;
                        const experiment = FilterExperiments(experiments, serie.id);
                        return (
                            <div key={`i-${i}`}>
                                <div className="title-list" id={`serie-${label}`}>{title}</div>
                                <div className="list" key={`b-${i}`}>
                                    {experiment.map((el, i) => {
                                        let item = {
                                            path: `${label}/${el.number}-${el.slug}`,
                                            name: el.name,
                                            number: el.number,
                                            route: el.route,
                                        };
                                        return (
                                            <BlockLogoExperiments label="experiments" item={item} key={i} />
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleExperiments item={items} authors={authors} total={experiments.length} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                    <BlockExperiments series={series} experiments={experiments} total={experiments.length} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}
